<template>
  <tbody>
    <tr :class="{'d-none': sameDateAsAbove}" class="no-interaction">
      <td class="d-table-cell d-md-none lead fw-bold" colspan="1">{{ date }} {{ dayOfWeek }}</td>
      <td class="d-none d-md-table-cell lead fw-bold" colspan="2">{{ date }} {{ dayOfWeek }}</td>
      <td class="align-middle text-end no-line-break fw-bold">
        <span class="d-none d-md-inline">共&nbsp;</span>
        {{ Math.trunc(totalDuration / 60).toString() }}
        : {{ (totalDuration % 60).toString().padStart(2, '0') }}
        <span class="d-none d-md-inline">&nbsp;&nbsp;</span>
      </td>
    </tr>
    <tr :class="{'editable': editable}" v-on="editable ? {click: openEditTimeEntryModal} : {}">
      <td class="border-start long-column">
        <span class="d-block mb-1">{{ projectName }}</span>
        <span class="d-block d-md-none mb-1">{{ serviceName }}<!-- eslint-disable-next-line -->
          <span v-if="description.length > 0" class="text-muted">&nbsp; |&nbsp; {{ description }}</span>
        </span>
        <span class="color-marker" :style="{'background-color': userColor}"></span>
        <span class="text-muted">{{ userFirstName }} {{ userLastName }}</span>
      </td>
      <td class="d-none d-md-table-cell">
        <span class="d-block mb-1">{{ serviceName }}</span>
        <span class="preserve-line-break text-muted">{{ description }}</span>
      </td>
      <td class="border-end align-middle width-fit-content text-end">
        <span>{{ duration }}</span>
        <span class="d-none d-md-inline">&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span class="d-block d-md-none spacer"></span>
        <div class="dropdown d-inline-block">
          <a
            class="btn btn-light btn-sm dropdown-toggle"
            href="#" role="button" id="dropdownMenuLink"
            data-bs-toggle="dropdown" aria-expanded="false"
          ><i class="bi bi-three-dots-vertical"></i></a>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <li>
              <a
                class="dropdown-item"
                role="button"
                @click="copyTimeEntry"
              >拷貝</a>
            </li>
            <li v-if="editable">
              <a
                class="dropdown-item"
                data-bs-toggle="modal"
                href="#edit-time-entry-modal"
              >編輯</a>
            </li>
            <li v-if="editable">
              <a
                class="dropdown-item text-danger"
                data-bs-toggle="modal"
                href="#delete-time-entry-modal"
              >刪除</a>
            </li>
          </ul>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { Modal } from 'bootstrap';

export default {
  name: 'TimeEntry',
  props: {
    id: Number,
    userFirstName: String,
    userLastName: String,
    userColor: String,
    projectName: String,
    serviceName: String,
    description: String,
    date: String,
    dayOfWeek: String,
    duration: String,
    sameDateAsAbove: Boolean,
    totalDuration: Number,
    editable: Boolean,
    highlighted: { type: Boolean, default: false },
  },
  methods: {
    openEditTimeEntryModal(event) {
      this.$parent.lastClickedTimeEntryId = this.id;
      // eslint-disable-next-line no-restricted-syntax
      for (const element of event.composedPath()) {
        if (element === document.body) {
          break;
        }
        if (element.classList.contains('dropdown')) {
          return;
        }
      }
      const modalElement = document.querySelector('#edit-time-entry-modal');
      const modal = Modal.getOrCreateInstance(modalElement);
      modal.show();
    },
    copyTimeEntry() {
      this.$parent.lastClickedTimeEntryId = this.id;
      this.$emit('copy');
    },
  },
  mounted() {
    if (this.highlighted) {
      const element = this.$el;
      if (typeof element.scrollIntoViewIfNeeded === 'function') {
        // only supported by WebKit
        setTimeout(() => element.scrollIntoViewIfNeeded(true), 500);
      } else {
        // other browsers
        setTimeout(() => element.scrollIntoView({ block: 'center' }), 500);
      }
      setTimeout(() => element.classList.add('highlight'), 500);
      setTimeout(() => element.classList.remove('highlight'), 5500);
    }
  },
  updated() {
    if (this.highlighted) {
      const element = this.$el;
      if (typeof element.scrollIntoViewIfNeeded === 'function') {
        // only supported by WebKit
        setTimeout(() => element.scrollIntoViewIfNeeded(true), 500);
      } else {
        // other browsers
        setTimeout(() => element.scrollIntoView({ block: 'center' }), 500);
      }
      setTimeout(() => element.classList.add('highlight'), 500);
      setTimeout(() => element.classList.remove('highlight'), 5500);
    }
  },
};
</script>

<style scoped lang="scss">
@import "~bootstrap/scss/bootstrap-grid";
tr.editable {
  cursor: pointer;
}
tr:not(.no-interaction) {
  transition: all 1s ease-in;
  transition-property: background-color, box-shadow;
}
.highlight tr:not(.no-interaction) {
  background-color: #0069b71f;
}
tr.no-interaction {
  cursor: default;
  &:hover > * {
    background-color: transparent;
    --bs-table-accent-bg: transparent;
  }
}
tr td {
  padding-top: 1rem;
  padding-bottom: 1rem;
  &:first-of-type {
    padding-left: 1rem;
  }
  &:last-of-type {
    padding-right: 1rem;
  }
  &.width-fit-content {
    width: 1%;
    white-space: nowrap;
  }
  &.long-column {
    @include media-breakpoint-up(md) {
      min-width: 120px;
    }
    @include media-breakpoint-up(lg) {
      min-width: 167px;
    }
    @include media-breakpoint-up(xl) {
      min-width: 255px;
      width: 37%;
    }
  }
}
.preserve-line-break {
  white-space: pre-wrap;
}
.no-line-break {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: none;
}
.dropdown-toggle.btn-light.btn-sm {
  background-color: #e9ecef;
  border-color: #e9ecef;
  border-radius: 0.5rem;
}
.dropdown-menu {
  min-width: 4.25rem;
}
.spacer {
  height: 10px;
}
.color-marker {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 10px;
  vertical-align: 0.05rem;
  border-radius: 5px;
  opacity: 0.6;
}
</style>
